import fetchHandler from "../../utils/fetchHandler";
import { NUTRITION_JOURNAL } from "../types/actions";

export const getNutritionJournalSummary = (queryString) => {
	const fetchOptions = {
		url: `/api/journals/summary?${queryString}`,
		method: "GET",
		actionType: NUTRITION_JOURNAL.GET_NUTRITION_JOURNAL_SUMMARY
	};
	return fetchHandler(fetchOptions);
};

export const getNutritionGoals = (queryString) => {
	const fetchOptions = {
		url: `/api/goals/?${queryString}`,
		method: "GET",
		actionType: NUTRITION_JOURNAL.GET_NUTRITION_GOALS
	};
	return fetchHandler(fetchOptions);
};

export const getNutrionJournalEntries = (queryString) => {
	const fetchOptions = {
		url: `/api/journals/?${queryString}`,
		method: "GET",
		actionType: NUTRITION_JOURNAL.GET_NUTRITION_JOURNAL_ENTRIES
	};
	return fetchHandler(fetchOptions);
};

export const addNutritionJournal = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/journals/`,
		method: "POST",
		actionType: NUTRITION_JOURNAL.ADD_NUTRITION_JOURNAL,
		body: JSON.stringify(values)
	};

	return fetchHandler(fetchOptions, successHandler);
};

export const editNutritionJournal = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/journals/${values.id}`,
		method: "PUT",
		actionType: NUTRITION_JOURNAL.EDIT_NUTRITION_JOURNAL,
		body: JSON.stringify(values)
	};

	return fetchHandler(fetchOptions, successHandler);
};

export const deleteNutritionJournal = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/journals/${values.id}`,
		method: "DELETE",
		actionType: NUTRITION_JOURNAL.DELETE_NUTRITION_JOURNAL
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const saveNutritionGoals = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/goals/${values.id}`,
		method: "PUT",
		body: JSON.stringify(values),
		actionType: NUTRITION_JOURNAL.SAVE_NUTRITION_GOALS
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const createNutritionGoals = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/goals/`,
		method: "POST",
		body: JSON.stringify(values),
		actionType: NUTRITION_JOURNAL.CREATE_NUTRITION_GOALS
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const journalUpdate = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/journal_update/${values.id}`,
		method: "PUT",
		body: JSON.stringify(values),
		actionType: NUTRITION_JOURNAL.UPDATE_HYDRATION
	};
	return fetchHandler(fetchOptions, successHandler);
};
